// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/AlipayCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleOutlinedSvg
  }));
};

AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
export default React.forwardRef(AlipayCircleOutlined);